import { Col, Form, Input, Row } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../../../components/DraggableModal";
import { EntReservoir } from "../../../models/reservoir";
import { MapAddPolygon } from "../../../components/maps/MapAddPolygon";
import modal from "antd/es/modal";
import { SelectYear } from "../../../components/selects";

enum FormField {
    nameKy,
    nameRu,
    yearOfConstruction,
    designCapacity,
    polygonJson
}

interface IProps {
    show: boolean;
    reservoir: EntReservoir;
    onHide: () => void;
    onSubmit: (pos: EntReservoir) => Promise<boolean>;
}

export const AddReservoirsModal = (props: IProps) => {
    const { t } = useTranslation();
    const [form] = useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [polygon, setPolygon] = useState<string | null>(null)

    useEffect(() => {
        if (props.show) setFieldsFromEntity();
    }, [props.show]);

    const setFieldsFromEntity = (): void => {
        form.setFields([
            { name: FormField.nameKy, value: props.reservoir.nameKy },
            { name: FormField.nameRu, value: props.reservoir.nameRu },
            { name: FormField.yearOfConstruction, value: props.reservoir.yearOfConstruction },
            { name: FormField.designCapacity, value: props.reservoir.designCapacity },
            { name: FormField.polygonJson, value: props.reservoir.polygonJson },
        ]);
        if (props.reservoir.polygonJson !== null) {
            setPolygon(props.reservoir.polygonJson)
        }
    };

    const setEntityFromFields = (): EntReservoir => {
        let res = _.cloneDeep(props.reservoir);
        res.nameKy = form.getFieldValue(FormField.nameKy);
        res.nameRu = form.getFieldValue(FormField.nameRu);
        res.yearOfConstruction = form.getFieldValue(FormField.yearOfConstruction);
        res.designCapacity = form.getFieldValue(FormField.designCapacity);

        if (polygon !== null) {
            res.polygonJson = polygon;
        }
        return res;
    }
    const hideModal = () => {
        props.onHide();
        setPolygon(null)
    }
    const handleSubmit = async () => {
        setLoading(true);
        try {
            await form.validateFields();
            if (polygon !== null) {
                const data = setEntityFromFields();
                const result = await props.onSubmit(data);
                if (result) hideModal();
            } else {
                modal.error({ title: t('msg.error'), content: t('reservoir.reservoir_name_desc') });
            }


        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <DraggableModal
                title={props.reservoir.id ===  0 ? t('general.add') : t('general.edit')}
                visible={props.show}
                onCancel={() => { hideModal() }}
                onSubmit={handleSubmit}
                submitLoading={loading}
                width={1000}
            >
                <Form
                    initialValues={{ remember: true }}
                    autoComplete="off"
                    layout="vertical"
                    form={form}
                >
                    <Row style={{ margin: 0 }} gutter={16}>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label={ t('general.nameKy') }
                                name={FormField.nameKy}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="text" />
                            </Form.Item>
                            <Form.Item
                                label={t('general.nameRu')}
                                name={FormField.nameRu}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type="text" />
                            </Form.Item>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <Form.Item
                                label={ t('reservoir.year_construction') }
                                name={FormField.yearOfConstruction}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <SelectYear />
                            </Form.Item>
                            <Form.Item
                                label={ t('reservoir.design_capacity') }
                                name={FormField.designCapacity}
                                rules={[{ required: true, message: t("msg.fill_in_the_field") }]}
                            >
                                <Input type='number'/>
                            </Form.Item>

                        </Col>
                    </Row>
                    <MapAddPolygon
                        setPolygon={setPolygon}
                        polygon={polygon}
                    />
                </Form>
            </DraggableModal>
        </>
    )
}
